import { BIND_TYPE, DURATION_UNIT, FIELD_VALUE_TYPE, PREFILL_OPTIONS } from '@constants'
import { AutocompleteOption, GETDropDownFilter } from '@types'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

export type FieldForm = {
  id?: number | string
  code: string
  bindType?: BIND_TYPE | null
  title: string
  value: string | null
  valueType: FIELD_VALUE_TYPE | null
  objectValue?: string | null
  pathArray: EmbeddedObject[]
  objectFormCode?: AutocompleteOption | string | null
  embeddedObjectCode?: AutocompleteOption<string> | null
  dropDownObjectCode?: AutocompleteOption<string> | null
  objectFormTitle?: string
  required: boolean
  editField: boolean
  params?: string
  json?: boolean
  dropDownListCode?: AutocompleteOption | string | null
  dropDownWindowCode?: AutocompleteOption | string | null
  dropDownListFilters: GETDropDownFilter[]
  dropDownWindowFilters: GETDropDownFilter[]
  isDefaultPlaceholder: boolean
  placeholderValue: string
  formatDate: AutocompleteOption | null
  isEnabledTimeMenu: boolean
  asCheckbox: boolean
  asDuration: boolean
  durationUnit: DURATION_UNIT | null
  preFillSourceObject?: AutocompleteOption<string> | null
  preFillFilterObject?: AutocompleteOption<string> | null
  preFillLink?: EmbeddedObject[] | null
  preFillFilterName?: EmbeddedObject[] | null
  preFillLinkStr?: string
  preFillFilterNameStr?: string
  preFillType?: PREFILL_OPTIONS
  preFillStaticValue?: string
  isMultiline?: boolean
  isAddFieldValues: boolean
  fieldValues: FieldValueType[]
  generalFilterField?: string
  conditionsDisabled?: string
  targetPathArray?: EmbeddedObject[]
  targetPathArrayValue?: string
}

export type FieldValueType = {
  label: string
  value: string | number
}

export const getDefaultValue = (): FieldForm => {
  return {
    code: '',
    bindType: null,
    title: '',
    value: null,
    valueType: null,
    pathArray: [],
    objectValue: null,
    embeddedObjectCode: null,
    dropDownObjectCode: null,
    objectFormCode: null,
    required: false,
    editField: true,
    params: '',
    json: false,
    dropDownListCode: null,
    dropDownWindowCode: null,
    dropDownListFilters: [],
    dropDownWindowFilters: [],
    isDefaultPlaceholder: true,
    placeholderValue: '',
    formatDate: null,
    isEnabledTimeMenu: true,
    asCheckbox: false,
    asDuration: false,
    durationUnit: DURATION_UNIT.SECONDS,
    preFillSourceObject: null,
    preFillLink: [],
    preFillFilterObject: null,
    preFillFilterName: [],
    isMultiline: false,
    isAddFieldValues: false,
    fieldValues: [],
    generalFilterField: '',
    conditionsDisabled: '',
    targetPathArray: [],
  }
}
